var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "180px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("StockStructureConfiguration.Form.Create"))),
      ]),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("StockStructureConfiguration.Form.Code") } },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("StockStructureConfiguration.Form.pps"),
              clearable: "",
              disabled: "",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("StockStructureConfiguration.Form.Name"),
            prop: "name",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
              clearable: "",
            },
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }